const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getMappings(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.enrollmentStatus) params.append('enrollmentStatus', filters.enrollmentStatus);
  if (filters.unmappedOnly) params.append('unmappedOnly', 'true');
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/integrations/energyhub/mappings${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch mappings');
  }
  
  return response.json();
}

export async function getMapping(orgId, mappingId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/mappings/${mappingId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch mapping');
  }
  
  const data = await response.json();
  return data.mapping;
}

export async function updateMapping(orgId, mappingId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/mappings/${mappingId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to update mapping');
  }
  
  const data = await response.json();
  return data.mapping;
}
